import React, { useState } from "react";
import "./AIChatAssistant.css";
import aiLogo from "../assets/ai-logo.jpg";

const AIChatAssistant = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { sender: "bot", text: "Hi! I'm your AI Assistant. Ask me anything about AI StudyMate." }
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const toggleChat = () => setIsOpen(!isOpen);

  const handleSend = async () => {
    if (!input.trim()) return;

    const newMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, newMessage]);
    setInput("");
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/assistant`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: input }),
      });

      const data = await res.json();

      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: data.reply || "Sorry, I didn’t understand that." },
      ]);
    } catch (error) {
      console.error(error);
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "⚠️ Couldn't reach AI Assistant. Please try again." },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="ai-float-btn" onClick={toggleChat}>
        <img src={aiLogo} alt="AI Assistant" className="ai-logo" />
      </div>

      {isOpen && (
        <div className="ai-chat-box">
          <div className="ai-chat-header">
            🤖 AI Assistant
            <button className="close-btn" onClick={toggleChat}>✖</button>
          </div>
          <div className="ai-chat-body">
            {messages.map((msg, i) => (
              <div key={i} className={`ai-msg ${msg.sender === "user" ? "user" : "bot"}`}>
                {msg.text}
              </div>
            ))}
            {loading && <div className="ai-msg bot">Thinking...</div>}
          </div>
          <div className="ai-chat-input">
            <input
              type="text"
              placeholder="Ask me anything..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSend()}
            />
            <button onClick={handleSend}>Send</button>
          </div>
        </div>
      )}
    </>
  );
};

export default AIChatAssistant;
